export enum MutationTypes {
    SET_AUTHENTIFICATION_DATA_LOADING = 'setAuthentificationDataLoading',
    HAS_AUTHENTIFICATION_ERROR = "hasAuthentificationError",
    SET_AUTHENTIFICATION_PROFILE = "setAuthentificationProfile",
    SET_AUTHENTIFICATION_HELPER_TEXT = "setAuthentificationHelperText",
    SET_AUTHENTIFICATION_AUTHENTICATED = "setAuthentificationAutenticated"
}